import { formatUTCTime } from "../../../global/utils/unixToLocalTime";

export const PurchaseItemsColumns = () => {
  return [
    {
      title: "License Item",
      dataIndex: "Item",
      key: "Item",
      onHeaderCell: () => ({ onClick: () => {} }),
      //   sorter: (a, b) => () => {},
      //   sortIcon: () => (
      //     <SortIcon
      //       sortOrder={modParams.order}
      //       columnKey="ProductionDesc"
      //       sortBy={modParams.sort_by}
      //     />
      //   ),
      //   onHeaderCell: () => ({
      //     onClick: () =>
      //       setParams((prev) => ({
      //         ...modParams,
      //         sort_by: "ProductionDesc",
      //         order: modParams.order === "desc" ? "asc" : "desc",
      //       })),
      //   }),
    },
    {
      title: "License",
      dataIndex: "CodeName",
      key: "CodeName",
      onHeaderCell: () => ({ onClick: () => {} }),
    },
    {
      title: "Price",
      dataIndex: "Price",
      key: "Price",
      onHeaderCell: () => ({ onClick: () => {} }),
      render: (value) => (value ? `$ ${value}` : null),
    },
    {
      title: "Used",
      dataIndex: "Used",
      key: "Used",
      onHeaderCell: () => ({ onClick: () => {} }),
    },
    {
      title: "Used MAC",
      dataIndex: "UsedMac",
      key: "UsedMac",
      onHeaderCell: () => ({ onClick: () => {} }),
    },
    {
      title: "Used Time",
      dataIndex: "UsedTime",
      key: "UsedTime",
      onHeaderCell: () => ({ onClick: () => {} }),
      render: (text) => (text ? formatUTCTime(text) : ""),
    },
    {
      title: "",
      fixed: "right",
      width: 0,
      align: "center",
    },
  ];
};
